import { render, staticRenderFns } from "./TasksDialog.vue?vue&type=template&id=50a4b987&scoped=true&"
import script from "./TasksDialog.vue?vue&type=script&lang=js&"
export * from "./TasksDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a4b987",
  null
  
)

export default component.exports